import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MUIPaper from '@material-ui/core/Paper';
import cn from 'classnames';
import { testAttr } from '../../helpers';
import CheckboxIcon from './CheckboxIcon';
import useStyles from './Checkbox.styles';
export const Checkbox = ({ className, checked, indeterminate = false, label, round, disabled, onClick, onCheckboxClick, onChange, testId, }) => {
    const classes = useStyles();
    const checkbox = (_jsxs(MUIPaper, Object.assign({ className: cn(classes.inputContainer, disabled && classes.disabled, round && classes.round, indeterminate && classes.indeterminate, !label && className), elevation: 0 }, { children: [_jsx("input", Object.assign({ type: "checkbox", className: classes.input, checked: checked, disabled: disabled, onChange: (e) => {
                    if (onChange) {
                        onChange(e.target.checked);
                    }
                }, onClick: (e) => {
                    if (onCheckboxClick)
                        onCheckboxClick(e);
                    else if (!label && onClick)
                        onClick(e);
                } }, testAttr(testId))), _jsx("div", Object.assign({ className: cn(classes.checkbox, (checked || indeterminate) && classes.checked, indeterminate && classes.indeterminate) }, { children: (checked || indeterminate) && (_jsx(CheckboxIcon, { indeterminate: indeterminate, round: round })) }))] })));
    if (label) {
        return (_jsxs("label", Object.assign({ className: cn(classes.labelContainer, disabled && classes.disabled, className), onClick: onClick }, { children: [checkbox, _jsx("div", Object.assign({ className: classes.label }, { children: label }))] })));
    }
    return checkbox;
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map